var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.5,
    height: 23.5,
    viewBox: "0 0 23.5 23.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1288",
    "data-name": "Grupo 1288",
    transform: "translate(-853.427 -57.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5134",
    "data-name": "Caminho 5134",
    d: "M26.5,15.25A11.25,11.25,0,1,0,15.25,26.5,11.25,11.25,0,0,0,26.5,15.25Z",
    transform: "translate(849.927 54)",
    fill: "#4095c2",
    stroke: "#4095c2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_4406",
    "data-name": "Ret\\xE2ngulo 4406",
    width: 10.434,
    height: 2.7,
    rx: 1,
    transform: "translate(859.96 67.9)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_4407",
    "data-name": "Ret\\xE2ngulo 4407",
    width: 10.434,
    height: 2.7,
    rx: 1,
    transform: "translate(866.527 64.033) rotate(90)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.3db0c463.svg";
export { ForwardRef as ReactComponent };